export default __webpack_public_path__ + "static/media/FEMUR_CORONAL.730c44e7.jpg";